//
import { Produto } from '../../shared/entity/Produto';
import { formatarDinheiro } from '../../shared/helper';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { TXT_M, TXT_P, TXT_G } from '../../constants';
import Divider from '../Generic/Divider';
import Touchable from '../Generic/Touchable';

type Props = {
  produto: Produto;
  goToProduto: (id: number) => void;
  hideDivider?: boolean;
};

const ItemProduto: React.FC<Props> = (props) => {
  const { produto, goToProduto, hideDivider } = props;

  if (!produto.tamanhos || produto.tamanhos.length === 0) {
    return null;
  }

  const getPrecoMinMax = () => {
    if (produto.tamanhos.length === 1) {
      return `R$${formatarDinheiro(produto.tamanhos[0].preco)}`;
    } else {
      let precoMin = produto.tamanhos[0].preco;
      let precoMax = 0;
      produto.tamanhos.map((tamanho) => {
        if (tamanho.preco > precoMax) {
          precoMax = tamanho.preco;
        }
        if (tamanho.preco < precoMin) {
          precoMin = tamanho.preco;
        }
      });
      return `R$${formatarDinheiro(precoMin)} - R$${formatarDinheiro(precoMax)}`;
    }
  };

  return (
    <Touchable onPress={() => goToProduto(produto.id)}>
      <View style={styles.header}>
        <Text style={styles.titulo}>{produto.nome}</Text>
        <Text style={styles.preco}>{getPrecoMinMax()}</Text>
      </View>
      {produto.descricao !== '' && <Text style={styles.descricao}>{produto.descricao}</Text>}
      {!hideDivider && <Divider style={{ marginTop: 10 }} />}
    </Touchable>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingTop: 10,
    backgroundColor: '#fff',
    width: '100%',
    flexDirection: 'row'
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  titulo: {
    fontSize: TXT_M,
    fontWeight: '700',
    color: colors.darkGrey,
    marginBottom: 5,
    flex: 1
  },
  descricao: {
    fontSize: TXT_P
  },
  preco: {
    fontSize: TXT_P,
    fontWeight: '700',
    color: colors.values
  }
});

export default ItemProduto;
